import { createDispatchHook, createSelectorHook } from 'react-redux'
import type { TypedUseSelectorHook } from 'react-redux'

import { avatarContext } from '.'
import type { AppState, AppDispatch } from './Types'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAvatarDispatch = createDispatchHook<AppDispatch>(avatarContext)
export const useAvatarSelector: TypedUseSelectorHook<AppState> = createSelectorHook(avatarContext)
